import React from "react";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";

import CardSection from "./CardSection";
import ReactToolTip from 'react-tooltip';
import ResourceService from "../../services/resource.service";
import CommonMessage from "../common/commonMessage";
import $ from 'jquery';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from "../../constants/server.constant";
import Validate from '../common/validate';
import { userService } from "./../../services/user.service";
import ReCAPTCHA from "react-google-recaptcha";

class CheckoutForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      billingAddress: '',
      zipCode: '',
      billingAddressEmpty: false,
      zipCodeEmpty: false,
      showLoader: false,
      message: '',
      lastdigits: '',
      month: '',
      year: '',
      showCardSection: false,
      prevBillingAddress: '',
      prevZipCode: '',
      msgType: '',
      isUserSubscribed: false,
      firstName: "",
      lastName: "",
      countryCode: "USA +1",
      countryLabel: "USA +1",
      phone: "",
      firstnameempty: false,
      lastnameempty: false,
      countrycodeempty: false,
      phoneempty: false,
      firstnameregex: false,
      lastnameregex: false,
      phoneregex: false,
      showPersonDetails: false,
      isPhoneVerifyPopup: false,
      otp: "",
      otpempty: false,
      otpErr: false,
      stripeToken: "",
      showVerifyLoader: false,
      smsType: "",
      cancelButton: false,
      isSuspended: localStorage.getItem("status") === 'S',
      pendingCharges: null,
      ccDetails: null,
      showReactivatePopup: false,
      showReadOnlyCCDiv: false,
      showPhoneOtpPopup: true
    };
    this.billingAddressInput = React.createRef();
    this.zipCodeInput = React.createRef();
    this.toggleStripeForm = this.toggleStripeForm.bind(this);
    this.showStripeForm = this.showStripeForm.bind(this);
    this.checkForSubscription = this.checkForSubscription.bind(this);
    this.firstNameFocus = React.createRef();
    this.lastNameFocus = React.createRef();
    this.phoneNUmberFocus = React.createRef();
    this.getFocus = this.getFocus.bind(this);
    this.verifyOtp = this.verifyOtp.bind(this);
    this.sendOtp = this.sendOtp.bind(this);
    this.otpInput = React.createRef();
    this.handleOTPKeyUp = this.keyUpHandler.bind(this, 'otpInput');
    this.escfunction = this.escfunction.bind(this);
    this.recaptchaRef = React.createRef();
    this.reactivateAccConfirmRef = React.createRef();
  }

  keyUpHandler(refName, e) {
    if(refName == "otpInput") {
      if(e.keyCode == 13) {
        this.verifyOtp();
      }
      if(this.state.otp.length < 6) {
        $('#verify_btn').addClass("disabled");
      } else {
        $('#verify_btn').removeClass("disabled");
      }
    }
  }

  openPhoneVerifyPopup = () => {
    this.setState({
      otp: "",
      isPhoneVerifyPopup: true
    }, () => {
      this.toggleVerifyButton();
    });
    $('body').addClass("no_scroll");
  };

  closePhoneVerifyPopup = () => {
    this.setState({
      isPhoneVerifyPopup: false,
      showLoader: false
    });
    $('body').removeClass("no_scroll");

  };


  verifyOtp = () => {
    this.setState({
      otpempty: false,
      otpErr: false
    });
    if(this.state.otp.trim() == "") {
      this.setState({
        otpempty: true
      });
      this.otpInput.current.focus();
      return;
    }

    if(!Validate("otp", this.state.otp.trim()) || this.state.otp.trim().length < 6) {
      this.setState({
        otpErr: true
      });
      this.otpInput.current.focus();
      return;
    }

    this.setState({
      otpempty: false,
      otpErr: false
    });
    var ccDetails = {
      "ccdetails": {
        "token": JSON.stringify(this.state.stripeToken),
        "userid": localStorage.getItem('userId'),
        "billingaddress": this.state.billingAddress,
        "zipcode": this.state.zipCode,
        "firstname": this.state.firstName,
        "lastname": this.state.lastName,
        "countryCode": this.state.countryCode,
        "phone": this.state.phone,
        "isDetailsUpdated": "NO",
        "otp": this.state.otp.trim()
      }
    };
    this.addCCDetails(ccDetails);
  };

  resendOtpSms() {
    this.setState({
      smsType: "resend"
    }, () => {
      if(this.recaptchaRef.current) {
        this.recaptchaRef.current.execute();
      }
    });

  }

  sendOtp = (type, event) => {
    if(type == "send") {
      this.setState({
        showLoader: true,
      });
    }
    var cLabel = $("#countryCode option:selected").text();
    var c = cLabel.split('+');
    var cCode = '+' + c[1];
    this.setState({
      countryLabel: cCode.trim()
    }, () => {
      var otpDetails = {
        "email": localStorage.getItem("email"),
        "countryCode": this.state.countryLabel,
        "phone": this.state.phone
      };
      if(type == "resend") {
        $("#resend_btn").attr('disabled', 'disabled');
        $('#resend_btn').addClass("disabled");
        setTimeout(() => {
          $("#resend_btn").removeAttr('disabled');
          $('#resend_btn').removeClass("disabled");
        }, 10000);
      }
      ResourceService.sendOtp(otpDetails, event).then(res => {
        //console.log(res)
        this.setState({
          showLoader: false
        });
        if(res === undefined) {
          if(type == "send") {
            this.setState({
              message: "Phone number could not be verified. Enter a valid phone number and try again.",
              msgType: 'error'
            });
            this.phoneNUmberFocus.current.focus();
            if(this.recaptchaRef.current) {
              this.recaptchaRef.current.reset();
            }
          } else {
            //if error occured during resend
            if(this.recaptchaRef.current) {
              this.recaptchaRef.current.reset();
            }
          }
        } else {
          clearInterval(this.timerId);
          this.startTimer();
          if(this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
          }
          if(type == "resend") {
            $('#verify_otp_msg').hide();
            $('#otp').removeAttr('disabled');
            $('#resend_msg').show();
            setTimeout(() => {
              $('#resend_msg').hide();
            }, 3000);
          } else {
            this.openPhoneVerifyPopup();
          }
          this.otpInput.current.focus();
        }
      });
    });

  };


  getFocus = (event, param) => {

    if(param === "zipcode") {
      if(this.state.billingAddress.length <= 0) {
        this.setState({
          billingAddressEmpty: true
        });
      }
      else {
        this.setState({
          billingAddressEmpty: false
        });
      }
    }
    if(param === "firstname") {
      if(this.state.billingAddress.length <= 0) {
        this.setState({
          billingAddressEmpty: true
        });
      }
      if(this.state.zipCode.length <= 0) {
        this.setState({
          zipCodeEmpty: true
        });
      }
      if(this.state.billingAddress.length > 0) {
        this.setState({
          billingAddressEmpty: false
        });
      }
      if(this.state.zipCode.length > 0) {
        this.setState({
          zipCodeEmpty: false
        });
      }
    }
    if(param === "lastname") {
      if(this.state.billingAddress.length <= 0) {
        this.setState({
          billingAddressEmpty: true
        });
      }
      if(this.state.zipCode.length <= 0) {
        this.setState({
          zipCodeEmpty: true
        });
      }
      if(this.state.firstName.length <= 0) {
        this.setState({
          firstNameEmpty: true
        });
      }
      if(this.state.billingAddress.length > 0) {
        this.setState({
          billingAddressEmpty: false
        });
      }
      if(this.state.zipCode.length > 0) {
        this.setState({
          zipCodeEmpty: false
        });
      }
      if(this.state.firstName.length > 0) {
        this.setState({
          firstNameEmpty: false
        });
      }
    }
    if(param === "phone") {
      if(this.state.billingAddress.length <= 0) {
        this.setState({
          billingAddressEmpty: true
        });
      }
      if(this.state.zipCode.length <= 0) {
        this.setState({
          zipCodeEmpty: true
        });
      }
      if(this.state.firstName.length <= 0) {
        this.setState({
          firstNameEmpty: true
        });
      }
      if(this.state.lastName.length <= 0) {
        this.setState({
          lastNameEmpty: true
        });
      }
      if(this.state.billingAddress.length > 0) {
        this.setState({
          billingAddressEmpty: false
        });
      }
      if(this.state.zipCode.length > 0) {
        this.setState({
          zipCodeEmpty: false
        });
      }
      if(this.state.firstName.length > 0) {
        this.setState({
          firstnameEmpty: false
        });
      }
      if(this.state.lastName.length > 0) {
        this.setState({
          lastNameEmpty: false
        });
      }
    }
    if(param === "lastfield") {
      if(this.state.phone.length <= 0) {
        this.setState({
          phoneNumberEmpty: true
        });
      }
      else {
        this.setState({
          phoneNumberEmpty: false
        });
      }
    }
  };

  componentWillUnmount() {
    document.removeEventListener("keyup", this.escfunction, false);
  }

  componentDidMount() {
    document.addEventListener("keyup", this.escfunction, false);
    this.setState({
      showLoader: true
    });
    this.checkForSubscription();
    userService.getUserDetails().then(res => {
      if(res === false) {
        this.setState({
          message: "Error while fetching details, try again!",
          showLoader: true
        });
        return;
      }
      if(res.data.body.phone) {
        this.setState({
          showPersonDetails: false,
        });
      } else {
        let fName = res.data.body.firstName;
        let lName = res.data.body.lastName;
        if(fName && lName) {
          this.setState({
            firstName: fName,
            lastName: lName,
            showPersonDetails: true,
            countryCode: "USA +1"
          });
        }
        else if(fName && !lName) {
          this.setState({
            firstName: fName,
            showPersonDetails: true,
            countryCode: "USA +1"
          });
        }
        else if(!fName && lName) {
          this.setState({
            lastName: lName,
            showPersonDetails: true,
            countryCode: "USA +1"
          });
        }
        else {
          this.setState({
            showPersonDetails: true,
            countryCode: "USA +1"
          });
        }

      }

    });
    $('#saveChangesButton').hide();
    $('#updateNewCardButton').hide();
  }

  escfunction(event) {
    if(event.keyCode === 27) {
      this.closePhoneVerifyPopup();
      this.closeReactivatePopup();
    }
  }

  checkForSubscription = () => {
    ResourceService.getSubscriptionDetails().then(resp => {
      //console.log(resp)
      if(resp === false) {
        this.setState({
          showLoader: false,
          message: "Error while getting user subscription details"

        });
        this.getCCDetails();

        return;
      }
      if(resp.error) {
        this.setState({
          showLoader: false,
          message: "Link your credit card for deploying high-speed NVMe SSD servers in seconds",
          cancelButton: false,
          isUserSubscribed: true
        }, () => this.getCCDetails());

        // $('#cancelButton').hide();
      } else {
        this.setState({
          isUserSubscribed: true,
          showPersonDetails: false, //no need to show person details if already cc details updated and user has to update in profile 
        }, () => this.getCCDetails());
      }
    });
  };

  getCCDetails() {
    ResourceService.getCCDetails().then(data => {
      //console.log(data)
      this.setState({
        showLoader: false
      });
      if(data && data !== "") {
        this.setCCDetails(data);

        this.toggleStripeForm(true);
      } else {
        this.toggleStripeForm(false);
      }
      this.getFlagMaster();
    }).catch(err => {
      console.log(err);
      this.setState({
        message: "Error while fetching details, try again!",
        showLoader: false,
        msgType: 'error'
      });
      this.getFlagMaster();
      return;
    });
  }

  getFlagMaster = () => {
    let userId = localStorage.getItem("userId");
    axiosInstance.get(API_HOST + "/user/checkphoneverify/" + userId, axiosRequestWithAuth).then(resp => {
      if(resp)
        this.setState({
          showPhoneOtpPopup: resp.data
        });
    })
      .catch(error => {
        console.log(error);
      });
  };

  setCCDetails(data) {
    this.setState({
      lastdigits: data.last4digits,
      billingAddress: data.billingaddress,
      zipCode: data.zipcode,
      cardType: data.cardType,
      month: data.expiry.toString().substring(0, 2),
      year: data.expiry.toString().substring(4),
      prevBillingAddress: data.billingaddress,
      prevZipCode: data.zipcode,
    });

    this.toggleStripeForm(data);
  }

  sendPhoneOtpByCaptcha() {
    if(this.recaptchaRef.current) {
      this.recaptchaRef.current.execute();
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({
      showLoader: true
    });
    const { stripe, elements } = this.props;
    if(!stripe || !elements) {
      this.setState({
        showLoader: false
      });
      return;
    }

    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card, { address_line1: this.state.billingAddress, address_zip: this.state.zipCode });
    if(result.error) {
      console.log(result.error.message);
      this.setState({
        message: "An error occurred while updating the card details. You can try again after sometime or try adding another card.",
        showLoader: false,
        msgType: 'error'
      });
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return;
    } else {
      //console.log(result.token);
      this.setState({
        stripeToken: result.token
      });
      if(this.validate()) {
        if(!this.state.showPersonDetails) {
          var ccDetails = {
            "ccdetails": {
              "token": JSON.stringify(this.state.stripeToken),
              "userid": localStorage.getItem('userId'),
              "billingaddress": this.state.billingAddress,
              "zipcode": this.state.zipCode,
              "isDetailsUpdated": "YES"
            }
          };
          this.state.isSuspended ? this.reactivateAccSubmit() : this.addCCDetails(ccDetails);
        } else {
          if(this.state.showPhoneOtpPopup) {
            this.setState({
              smsType: "send"
            }, () => this.recaptchaRef.current.execute());
          }
          else {
            var ccDetails = {
              "ccdetails": {
                "token": JSON.stringify(this.state.stripeToken),
                "userid": localStorage.getItem('userId'),
                "billingaddress": this.state.billingAddress,
                "zipcode": this.state.zipCode,
                "firstname": this.state.firstName,
                "lastname": this.state.lastName,
                "countryCode": this.state.countryCode,
                "phone": this.state.phone,
                "isDetailsUpdated": "NO"
              }
            };
            this.addCCDetails(ccDetails);
          }


        }
      }
      else {
        this.setState({
          showLoader: false
        });
      }
    }

  };

  addCCDetails(ccDetails) {

    this.setState({
      showLoader: true,
      showVerifyLoader: true
    });

    ResourceService.addCCDetails(JSON.stringify(ccDetails)).then(data => {
      this.setState({
        showVerifyLoader: false
      });
      //console.log(data);
      if(data == "CARD_ERROR") {
        this.setState({
          message: "An error occurred while updating the card details. You can try again after sometime or try adding another card.",
          showLoader: false,
          msgType: 'error'
        });
        this.closePhoneVerifyPopup();
        return;
      } else if(data == "INVALID_OTP") {
        $('#verify_otp_msg').show();
        setTimeout(() => {
          $('#verify_otp_msg').hide();
        }, 5000);
        this.setState({
          otp: ""
        }, () => {
          this.toggleVerifyButton();
        });
        this.otpInput.current.focus();
        return;
      } else if(data == "DETAILS_ERROR") {
        this.setState({
          message: "An error occurred while updating the details.",
          showLoader: false,
          msgType: 'error'
        });
        this.closePhoneVerifyPopup();
        return;
      }

      this.closePhoneVerifyPopup();
      localStorage.setItem("firstName", this.state.firstName);
      localStorage.setItem("lastName", this.state.lastName);
      localStorage.setItem("countryCode", this.state.countryCode);
      localStorage.setItem("phone", this.state.phone);
      let msg = "";
      if(this.state.showPersonDetails) {
        msg = "Account details have been updated";
      }
      else {
        msg = "Credit card details updated successfully.";
      }
      this.setState({
        message: msg,
        showLoader: false,
        msgType: 'success',
        showPersonDetails: false,
      });
      this.setCCDetails(data);
    }).catch(err => {
      console.log(err);
      if(this.state.isPhoneVerifyPopup) {
        $('#verify_otp_msg').show();
        setTimeout(() => {
          $('#verify_otp_msg').hide();
        }, 5000);
      } else {
        this.setState({
          message: "An error occurred while updating the card details. You can try again after sometime or try adding another card.",
          showLoader: false,
          msgType: 'error'
        });

      }
      return;
    });
  }


  startTimer() {
    //var mindisp = 0;
    //var secdis = 0;
    var countdown = 5 * 60 * 1000;
    //var timerId ;
    //clearInterval(timerId);
    this.timerId = setInterval(() => {
      countdown -= 1000;
      var min = Math.floor(countdown / (60 * 1000));
      //var sec = Math.floor(countdown - (min * 60 * 1000));  // wrong
      var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);
      if(min == 0 && sec == 0) {
        clearInterval(this.timerId);
        $('#otp_timer').html('The verification code has expired. Click "Resend OTP" to receive new code.');
        this.setState({
          otp: ""
        }, () => {
          $('#otp').attr("disabled", "disabled");
          this.toggleVerifyButton();
        });
      } else {
        this.mindisp = min;
        this.secdis = sec;
        if(min < 10)
          this.mindisp = "0" + min;
        if(sec < 10)
          this.secdis = "0" + sec;
        if(min == 0) {
          $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Seconds");
        } else {
          $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Minutes");
        }
      }

    }, 1000);

  }


  toggleVerifyButton() {
    $('#resend_msg').hide();
    if(this.state.otp.length < 6) {
      $('#verify_btn').attr("disabled", "disabled");
      $('#verify_btn').addClass("disabled");
    } else {
      $('#verify_btn').removeAttr("disabled");
      $('#verify_btn').removeClass("disabled");
    }
  }

  validate() {

    this.setState({
      billingAddress: this.state.billingAddress.trim(),
      zipCode: this.state.zipCode.trim(),
      firstName: this.state.firstName.trim(),
      lastName: this.state.lastName.trim(),
      phone: this.state.phone.trim(),
    });

    this.setState({
      billingAddressEmpty: false,
      zipCodeEmpty: false,
      firstNameEmpty: false,
      firstnameregex: false,
      lastNameEmpty: false,
      lastnameregex: false,
      phoneNumberEmpty: false,
      phoneregex: false,
      countrycodeempty: false
    });

    if(this.state.billingAddress.length <= 0) {
      this.setState({
        billingAddressEmpty: true,
      });
      this.billingAddressInput.current.focus();
      return false;
    } else if(this.state.zipCode.length <= 0) {
      this.setState({
        zipCodeEmpty: true,
      });
      this.zipCodeInput.current.focus();
      return false;
    }

    if(this.state.showPersonDetails) {
      if(this.state.firstName.length <= 0) {
        this.setState({
          firstNameEmpty: true
        });
        this.firstNameFocus.current.focus();
        return false;
      }

      if(!(Validate("firstName", this.state.firstName))) {

        this.setState({
          firstnameregex: true
        });
        this.firstNameFocus.current.focus();
        return false;
      }

      if(this.state.lastName.length <= 0) {
        this.setState({
          lastNameEmpty: true
        });
        this.lastNameFocus.current.focus();
        return false;
      }

      if(!(Validate("lastName", this.state.lastName))) {
        this.setState({
          lastnameregex: true
        });
        this.lastNameFocus.current.focus();
        return false;
      }

      if(this.state.countryCode.length <= 0) {
        this.setState({
          countrycodeempty: true
        });
        return false;
      }

      if(this.state.phone.length <= 0) {
        this.setState({
          phoneNumberEmpty: true
        });
        this.phoneNUmberFocus.current.focus();
        return false;
      }

      if(!(Validate("phoneNumber", this.state.phone))) {
        this.setState({
          phoneregex: true
        });
        this.phoneNUmberFocus.current.focus();
        return false;
      }

    }

    return true;
  }

  handleFormChanges = (event) => {

    this.setState({
      billingAddressEmpty: false,
      zipCodeEmpty: false,
      firstNameEmpty: false,
      firstnameregex: false,
      lastNameEmpty: false,
      lastnameregex: false,
      phoneNumberEmpty: false,
      phoneregex: false,
      countrycodeempty: false,
      otpempty: false
    });

    let name = event.target.name;
    let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    if(name == "billingAddress") {
      this.setState({
        billingAddressEmpty: false,
      });
      this.setState({ billingAddress: val }, function () {
        if(val.length > 0) {
          this.setState({
            billingAddressEmpty: false,
          });
        }
        else if(val.length <= 0) {
          this.setState({
            billingAddressEmpty: true,
          });
        }
      });
    }
    if(name == "zipCode") {
      this.setState({ zipCode: val }, function () {
        if(val.length > 0) {
          this.setState({
            zipCodeEmpty: false,
          });
        }
        else if(val.length <= 0) {
          this.setState({
            zipCodeEmpty: true,
          });
        }
      });
    }

    if(name === "firstName") {
      this.setState({ firstName: val }, function () {
        if(val.length > 0) {
          this.setState({
            firstNameEmpty: false,
            firstnameregex: false
          });
        }
      });
    }

    if(name === "lastName") {
      this.setState({ lastName: val }, function () {
        if(val.length > 0) {
          this.setState({
            lastNameEmpty: false,
            lastnameregex: false
          });
        }
      });
    }

    if(name === "countryCode") {
      this.setState({ countryCode: val }, function () {
        if(val.length > 0) {
          this.setState({
            countrycodeempty: false
          });
        }
      });
    }

    if(name === "phone") {
      this.setState({ phone: val }, function () {
        if(val.length > 0) {
          this.setState({
            phoneNumberEmpty: false,
            phoneregex: false
          });
          if(val.length >= 7) {
            $('#min_sev').addClass("success");
          } else {
            $('#min_sev').removeClass("success");
          }

          if(val.length > 0 && val.length <= 20) {
            $('#max_twe').addClass("success");
          } else {
            $('#max_twe').removeClass("success");
          }

          const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
          if(phoneNumRegex.test(val)) {
            $('#no_spe').addClass("success");
          } else {
            $('#no_spe').removeClass("success");
          }

        }
        else {
          $('#min_sev').removeClass("success");
          $('#max_twe').removeClass("success");
          $('#no_spe').removeClass("success");
        }
      });
    }

    if(name === "otp") {
      this.setState({ otp: val }, function () {
        if(val.length > 0) {
          this.setState({
            otpempty: false
          });
        }
      });
    }
  };

  toggleStripeForm(flag) {
    if(flag) {
      // $('#readOnlyCCDiv').show();
      $('#addNewCradButton').show();
      $('#updateNewCardButton').hide();
      $('#saveChangesButton').show();
      //$('#cancelButton').hide();
      this.setState({
        showReadOnlyCCDiv: true,
        showCardSection: false,
        cancelButton: false
      });
    } else {
      // $('#readOnlyCCDiv').hide();
      $('#addNewCradButton').hide();
      $('#updateNewCardButton').show();
      $('#saveChangesButton').hide();
      // $('#cancelButton').show();
      this.setState({
        showReadOnlyCCDiv: false,
      });
      if(this.state.isUserSubscribed) {
        if(this.state.isSuspended) {
          this.setState({
            showCardSection: true,
            cancelButton: true,
          });
        } else {
          this.setState({
            showCardSection: true,
            cancelButton: true,
          });
        }
      }
      else {
        this.setState({
          showCardSection: true,
          cancelButton: true
        });
      }

    }
  }
  updateCCDetails = () => {
    if(this.state.isSuspended) {
      this.showStripeForm();
      return;
    }
    if(this.validate()) {
      if(!this.state.showPersonDetails) {
        if(this.state.billingAddress == this.state.prevBillingAddress && this.state.zipCode == this.state.prevZipCode) {
          this.setState({
            message: "Make changes to save card details.",
            msgType: 'error'
          });
          return;
        }
      }
      this.setState({
        showLoader: true
      });
      var ccDetails = {
        "ccdetails": {
          "userid": localStorage.getItem('userId'),
          "billingaddress": this.state.billingAddress,
          "zipcode": this.state.zipCode,
        }
      };

      ResourceService.updateCCDetails(JSON.stringify(ccDetails)).then(data => {
        //console.log(data);
        if(data) {
          this.setState({
            showLoader: false,
            message: "Credit card details updated successfully.",
            prevBillingAddress: data.billingaddress,
            prevZipCode: data.zipcode,
            msgType: 'success'
          });
        } else {
          this.setState({
            showLoader: false,
            message: 'Error occurred while updating details',
            msgType: 'error'
          });
        }
      }).catch(err => {
        console.log(err);
        this.setState({
          showLoader: false,
          message: "Error occurred while updating details",
          msgType: "error"
        });
      });

    }

  };

  reactivateAccSubmit = () => {
    this.setState({
      showLoader: true,
    });
    ResourceService.fetchPendingCharges().then(resp => {
      if(resp?.data?.ok) {
        this.setState({
          showLoader: false,
          pendingCharges: resp.data.pendingAmount,
        }, () => {
          this.openReactivatePopup();
        });
      } else if(resp?.data?.error) {
        console.log(resp);
        this.setState({
          showLoader: false,
          message: resp.data.error,
          msgType: "error",
        });
        return;
      } else {
        this.setState({
          showLoader: false,
        });
      }
    }).catch(error => {
      console.log(error);
      this.setState({
        showLoader: false,
        message: "Unable to fetch pending charges, please try later",
        msgType: "error",
      });
    });
  };

  reactivateAccConfirm = (event) => {
    event.preventDefault();
    var ccDetails = {
      "ccdetails": {
        "token": JSON.stringify(this.state.stripeToken),
        "userid": localStorage.getItem('userId'),
        "billingaddress": this.state.billingAddress,
        "zipcode": this.state.zipCode,
        "isDetailsUpdated": "YES"
      }
    };
    this.setState({
      showLoader: true,
    });
    ResourceService.reactivateAccount(JSON.stringify(ccDetails)).then(resp => {
      let data = resp.data;
      //console.log(data);
      if(data == "CARD_ERROR") {
        this.setState({
          message: "An error occurred while updating the card details. You can try again after sometime or try adding another card.",
          showLoader: false,
          msgType: 'error'
        });
        this.closePhoneVerifyPopup();
        return;
      } else if(data == "INVALID_OTP") {
        $('#verify_otp_msg').show();
        setTimeout(() => {
          $('#verify_otp_msg').hide();
        }, 5000);
        this.setState({
          otp: ""
        }, () => {
          this.toggleVerifyButton();
        });
        this.otpInput.current.focus();
        return;
      } else if(data == "DETAILS_ERROR") {
        this.setState({
          message: "An error occurred while updating the details.",
          showLoader: false,
          msgType: 'error'
        });
        this.closePhoneVerifyPopup();
        return;
      } else if(data === "CHARGE_ERROR") {
        this.setState({
          showLoader: false,
          message: "Error occurred while charging pending amount with this card",
          msgType: "error",
        });
        return;
      }

      this.closePhoneVerifyPopup();
      this.closeReactivatePopup();
      localStorage.setItem("status", "Y");
      window.dispatchEvent(new Event('storage'));
      let msg = "Credit card details updated and account has been reactivated successfully";
      this.setState({
        message: msg,
        showLoader: false,
        msgType: 'success',
        showPersonDetails: false,
        isSuspended: false,
      });
      this.setCCDetails(data);
      this.toggleStripeForm(true);
    }).catch(err => {
      // console.log(err);
      this.closeReactivatePopup();
      this.setState({
        message: "An error occurred while updating the card details. You can try again after sometime or try adding another card.",
        showLoader: false,
        msgType: 'error'
      });
      return;
    });
  };

  openReactivatePopup = () => {
    this.setState({
      showReactivatePopup: true,
    }, () => {
      this.reactivateAccConfirmRef.current.focus();
    });
    $('body').addClass("no_scroll");
  };

  closeReactivatePopup = () => {
    this.setState({
      showReactivatePopup: false,
    });
    $('body').removeClass("no_scroll");
  };

  cancelCCUpdate = () => {
    this.toggleStripeForm(true);
    this.setState({
      billingAddress: this.state.prevBillingAddress,
      zipCode: this.state.prevZipCode
    });
  };

  showStripeForm() {
    this.setState({
      billingAddress: '',
      zipCode: ''
    });
    this.toggleStripeForm(false);
  }

  logout() {
    let userId = localStorage.getItem("userId");
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = API_HOST + "/login/logout?userId=" + userId;
  }

  onRecaptchaChange(event) {
    if(this.state.smsType == "resend")
      this.sendOtp("resend", event);
    else
      this.sendOtp("send", event);
  }

  render() {
    var role = localStorage.getItem("roleId");
    if(role == 1) {
      this.logout(); //if subuser tries to access just logout
      return null;
    }
    return (
      <React.Fragment>
        <div className="full_page_loader" style={ { display: this.state.showLoader ? 'block' : 'none', zIndex: this.state.isSuspended ? 100000 : 1 } }>
          <div className="loader_icon"></div>
        </div>
        <form onSubmit={ this.handleSubmit }>
          <div className="field_sec_wrap clearfix  ">
            <h3>Credit Card Information <span className="addCardNew" id="addNewCradButton" onClick={ () => this.showStripeForm(false) }>(Add new card)</span></h3>
            {/* <div className="acc_credit_radioWrap">
                <label className="custom_radio allCard active"><span className="icon_img"></span>
                    <input type="radio" checked="checked" name="accCreditUpgrade_options"></input>
                    <span className="checkmark"></span>
                </label>
                <label className="custom_radio payPal"><span className="icon_img"></span>
                    <input type="radio" name="accCreditUpgrade_options"></input>
                    <span className="checkmark"></span>
                </label>
            </div> */}

            <div className="field_wrap">
              <div className="common_txtBox_row credit_card_field" >
                <label>Card Number, expiry date and CVC
                  <span className="svg_wrap" data-tip data-for="creditcard">
                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                      <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                      <text autoFocus={ true } transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                    </svg>
                  </span>
                  <ReactToolTip id="creditcard" effect="solid" place="right" multiline={ true }>
                    For Visa, MasterCard, and Discover cards,<br></br> the CVV is the last 3 digit number located on the back of your card on <br></br> or above your signature line. For an American Express card,<br></br> it is the 4 digits on the FRONT above the end of your card number.
                  </ReactToolTip>
                </label>
                { this.state.showCardSection && <CardSection /> }

                <div className="customCreditCard_wrap" id="readOnlyCCDiv" style={ { display: this.state.showReadOnlyCCDiv ? "" : "none" } }>
                  <div className="customCreditCard">
                    <div className={ 'card_num ' + this.state.cardType }>************{ this.state.lastdigits }</div>
                    <div className="expiry_num"><span id="read_exp_month">{ this.state.month }</span>&nbsp;/&nbsp;<span id="read_exp_year">{ this.state.year }</span></div>
                  </div>
                </div>
                <p className="form_note">An amount of $1.00 will be charged and placed in temporary hold for validating your card. The amount will be refunded post verification. After that, you will be charged only for the services used.</p>
                <div id="card-element"></div>
                <div id="card-errors" role="alert"></div>
              </div>
            </div>
            <div className="field_wrap field_wrap_col1 field_border_btm">
              <div className="fw_row1">
                <div className="common_txtBox_row">
                  <label>Billing Address</label>
                  <input type="text" ref={ this.billingAddressInput } name="billingAddress" id="billingAddress" value={ this.state.billingAddress } onChange={ this.handleFormChanges } className="txtBox" maxLength="100" ></input>
                  <span className="err_msg" id="billingAddressErr" style={ { display: this.state.billingAddressEmpty ? 'inline-block' : 'none' } }>Billing Address cannot be blank</span>
                </div>

                <div className="common_txtBox_row">
                  <label>Zip Code</label>
                  <input type="text" ref={ this.zipCodeInput } name="zipCode" id="zipCode" value={ this.state.zipCode } onChange={ this.handleFormChanges } onFocus={ (e) => this.getFocus(e, "zipcode") } onClick={ (e) => this.getFocus(e, "zipcode") } className="txtBox" maxLength="20"></input>
                  <span className="err_msg" id="zipCodeErr" style={ { display: this.state.zipCodeEmpty ? 'inline-block' : 'none' } } >Zip Code cannot be blank</span>
                </div>
              </div>
            </div>
            <div className="field_wrap field_wrap_col1 field_border_btm" style={ { display: this.state.showPersonDetails ? "block" : "none" } }>
              <h3>Personal Details</h3>
              <div className="fw_row1">
                <div className="common_txtBox_row">
                  <label>First Name</label>
                  <input type="text" ref={ this.firstNameFocus } maxLength="20" name="firstName" value={ this.state.firstName } onFocus={ (e) => this.getFocus(e, "firstname") } onClick={ (e) => this.getFocus(e, "firstname") } onChange={ this.handleFormChanges } className="txtBox" />
                  <span className="err_msg" style={ { display: this.state.firstNameEmpty ? 'inline-block' : 'none' } } >First Name cannot be blank</span>
                  <span className="err_msg" style={ { display: this.state.firstnameregex ? 'inline-block' : 'none' } } >First name can contain a-z, A-Z and space</span> </div>
                <div className="common_txtBox_row">
                  <label>Last Name</label>
                  <input type="text" ref={ this.lastNameFocus } maxLength="20" name="lastName" value={ this.state.lastName } onFocus={ (e) => this.getFocus(e, "lastname") } onClick={ (e) => this.getFocus(e, "lastname") } onChange={ this.handleFormChanges } className="txtBox" />
                  <span className="err_msg" style={ { display: this.state.lastNameEmpty ? 'inline-block' : 'none' } } >Last Name cannot be blank</span>
                  <span className="err_msg" style={ { display: this.state.lastnameregex ? 'inline-block' : 'none' } } >First name can contain a-z, A-Z and space</span> </div>
              </div>
            </div>
            <div className="field_wrap field_wrap_col1 field_wrap_phone " style={ { display: this.state.showPersonDetails ? "block" : "none" } }>
              <h3>Phone Number</h3>
              <div className="fw_row1">
                <div className="common_txtBox_row">
                  <label>Country Code</label>
                  <div className="custom_select_box coutry_code_wrap">
                    <select name="countryCode" id="countryCode" value={ this.state.countryCode } onChange={ this.handleFormChanges } onFocus={ (e) => this.getFocus(e, "phone") } onClick={ (e) => this.getFocus(e, "phone") }>
                      <option value="" style={ { display: "none" } } disabled={ true }>Select the country code</option>
                      <option value="USA +1">USA +1</option>
                      <option value="Afghanistan +93">Afghanistan +93 </option>
                      <option value="Albania +355">Albania +355 </option>
                      <option value="Algeria +213">Algeria +213 </option>
                      <option value="American Samoa +684">American Samoa +684 </option>
                      <option value="Andorra +376">Andorra +376 </option>
                      <option value="Angola +244">Angola +244 </option>
                      <option value="Anguilla +1-264">Anguilla +1-264 </option>
                      <option value="Antarctica +672">Antarctica +672 </option>
                      <option value="Antigua and Barbuda +1-268">Antigua and Barbuda +1-268 </option>
                      <option value="Argentina +54">Argentina +54 </option>
                      <option value="Armenia +374">Armenia +374 </option>
                      <option value="Aruba +297">Aruba +297 </option>
                      <option value="Australia +61">Australia +61 </option>
                      <option value="Austria +43">Austria +43 </option>
                      <option value="Azerbaijan +994">Azerbaijan +994 </option>
                      <option value="Bahamas +1-242">Bahamas +1-242 </option>
                      <option value="Bahrain +973">Bahrain +973 </option>
                      <option value="Bangladesh +880">Bangladesh +880 </option>
                      <option value="Barbados +1-246">Barbados +1-246 </option>
                      <option value="Belarus +375">Belarus +375 </option>
                      <option value="Belgium +32">Belgium +32 </option>
                      <option value="Belize +501">Belize +501 </option>
                      <option value="Benin +229">Benin +229 </option>
                      <option value="Bermuda +1-441">Bermuda +1-441 </option>
                      <option value="Bhutan +975">Bhutan +975 </option>
                      <option value="Bolivia +591">Bolivia +591 </option>
                      <option value="Bosnia-Herzegovina +387">Bosnia-Herzegovina +387 </option>
                      <option value="Botswana +267">Botswana +267 </option>
                      <option value="Brazil +55">Brazil +55 </option>
                      <option value="Brunei Darussalam +673">Brunei Darussalam +673 </option>
                      <option value="Bulgaria +359">Bulgaria +359 </option>
                      <option value="Burkina Faso +226">Burkina Faso +226 </option>
                      <option value="Burundi +257">Burundi +257 </option>
                      <option value="Cambodia +855">Cambodia +855 </option>
                      <option value="Cameroon +237">Cameroon +237 </option>
                      <option value="Canada +1">Canada +1 </option>
                      <option value="Cape Verde +238">Cape Verde +238 </option>
                      <option value="Cayman Islands +1-345">Cayman Islands +1-345 </option>
                      <option value="Central African Republic +236">Central African Republic +236 </option>
                      <option value="Chad +235">Chad +235 </option>
                      <option value="Chile +56">Chile +56 </option>
                      <option value="China +86">China +86 </option>
                      <option value="Christmas Island +61">Christmas Island +61 </option>
                      <option value="Cocos (Keeling) Islands +61">Cocos (Keeling) Islands +61 </option>
                      <option value="Colombia +57">Colombia +57 </option>
                      <option value="Comoros +269">Comoros +269 </option>
                      <option value="Congo +242">Congo +242 </option>
                      <option value="Congo, Dem. Republic +243">Congo, Dem. Republic +243 </option>
                      <option value="Cook Islands +682">Cook Islands +682 </option>
                      <option value="Costa Rica +506">Costa Rica +506 </option>
                      <option value="Croatia +385">Croatia +385 </option>
                      <option value="Cuba +53">Cuba +53 </option>
                      <option value="Cyprus +357">Cyprus +357 </option>
                      <option value="Czech Rep. +420">Czech Rep. +420 </option>
                      <option value="Denmark +45">Denmark +45 </option>
                      <option value="Djibouti +253">Djibouti +253 </option>
                      <option value="Dominica +1-767">Dominica +1-767 </option>
                      <option value="Dominican Republic +809">Dominican Republic +809 </option>
                      <option value="Ecuador +593">Ecuador +593 </option>
                      <option value="Egypt +20">Egypt +20 </option>
                      <option value="El Salvador +503">El Salvador +503 </option>
                      <option value="Equatorial Guinea +240">Equatorial Guinea +240 </option>
                      <option value="Eritrea +291">Eritrea +291 </option>
                      <option value="Estonia +372">Estonia +372 </option>
                      <option value="Ethiopia +251">Ethiopia +251 </option>
                      <option value="Falkland Islands (Malvinas) +500">Falkland Islands (Malvinas) +500 </option>
                      <option value="Faroe Islands +298">Faroe Islands +298 </option>
                      <option value="Fiji +679">Fiji +679 </option>
                      <option value="Finland +358">Finland +358 </option>
                      <option value="France +33">France +33 </option>
                      <option value="French Guiana +594">French Guiana +594 </option>
                      <option value="Gabon +241">Gabon +241 </option>
                      <option value="Gambia +220">Gambia +220 </option>
                      <option value="Georgia +995">Georgia +995 </option>
                      <option value="Germany +49">Germany +49 </option>
                      <option value="Ghana +233">Ghana +233 </option>
                      <option value="Gibraltar +350">Gibraltar +350 </option>
                      <option value="Great Britain +44">Great Britain +44 </option>
                      <option value="Greece +30">Greece +30 </option>
                      <option value="Greenland +299">Greenland +299 </option>
                      <option value="Grenada +1-473">Grenada +1-473 </option>
                      <option value="Guadeloupe (French) +590">Guadeloupe (French) +590 </option>
                      <option value="Guam (USA) +1-671">Guam (USA) +1-671 </option>
                      <option value="Guatemala +502">Guatemala +502 </option>
                      <option value="Guinea +224">Guinea +224 </option>
                      <option value="Guinea Bissau +245">Guinea Bissau +245 </option>
                      <option value="Guyana +592">Guyana +592 </option>
                      <option value="Haiti +509">Haiti +509 </option>
                      <option value="Honduras +504">Honduras +504 </option>
                      <option value="Hong Kong +852">Hong Kong +852 </option>
                      <option value="Hungary +36">Hungary +36 </option>
                      <option value="Iceland +354">Iceland +354 </option>
                      <option value="India +91">India +91 </option>
                      <option value="Indonesia +62">Indonesia +62 </option>
                      <option value="Iran +98">Iran +98 </option>
                      <option value="Iraq +964">Iraq +964 </option>
                      <option value="Ireland +353">Ireland +353 </option>
                      <option value="Israel +972">Israel +972 </option>
                      <option value="Italy +39">Italy +39 </option>
                      <option value="Ivory Coast +225">Ivory Coast +225 </option>
                      <option value="Jamaica +1-876">Jamaica +1-876 </option>
                      <option value="Japan +81">Japan +81 </option>
                      <option value="Jordan +962">Jordan +962 </option>
                      <option value="Kazakhstan +7">Kazakhstan +7 </option>
                      <option value="Kenya +254">Kenya +254 </option>
                      <option value="Kiribati +686">Kiribati +686 </option>
                      <option value="Korea-North +850">Korea-North +850 </option>
                      <option value="Korea-South +82">Korea-South +82 </option>
                      <option value="Kuwait +965">Kuwait +965 </option>
                      <option value="Kyrgyzstan +996">Kyrgyzstan +996 </option>
                      <option value="Laos +856">Laos +856 </option>
                      <option value="Latvia +371">Latvia +371 </option>
                      <option value="Lebanon +961">Lebanon +961 </option>
                      <option value="Lesotho +266">Lesotho +266 </option>
                      <option value="Liberia +231">Liberia +231 </option>
                      <option value="Libya +218">Libya +218 </option>
                      <option value="Liechtenstein +423">Liechtenstein +423 </option>
                      <option value="Lithuania +370">Lithuania +370 </option>
                      <option value="Luxembourg +352">Luxembourg +352 </option>
                      <option value="Macau +853">Macau +853 </option>
                      <option value="Macedonia +389">Macedonia +389 </option>
                      <option value="Madagascar +261">Madagascar +261 </option>
                      <option value="Malawi +265">Malawi +265 </option>
                      <option value="Malaysia +60">Malaysia +60 </option>
                      <option value="Maldives +960">Maldives +960 </option>
                      <option value="Mali +223">Mali +223 </option>
                      <option value="Malta +356">Malta +356 </option>
                      <option value="Marshall Islands +692">Marshall Islands +692 </option>
                      <option value="Martinique (French) +596">Martinique (French) +596 </option>
                      <option value="Mauritania +222">Mauritania +222 </option>
                      <option value="Mauritius +230">Mauritius +230 </option>
                      <option value="Mayotte +269">Mayotte +269 </option>
                      <option value="Mexico +52">Mexico +52 </option>
                      <option value="Micronesia +691">Micronesia +691 </option>
                      <option value="Moldova +373">Moldova +373 </option>
                      <option value="Monaco +377">Monaco +377 </option>
                      <option value="Mongolia +976">Mongolia +976 </option>
                      <option value="Montenegro +382">Montenegro +382 </option>
                      <option value="Montserrat +1-664">Montserrat +1-664 </option>
                      <option value="Morocco +212">Morocco +212 </option>
                      <option value="Mozambique +258">Mozambique +258 </option>
                      <option value="Myanmar +95">Myanmar +95 </option>
                      <option value="Namibia +264">Namibia +264 </option>
                      <option value="Nauru +674">Nauru +674 </option>
                      <option value="Nepal +977">Nepal +977 </option>
                      <option value="Netherlands +31">Netherlands +31 </option>
                      <option value="Netherlands Antilles +599">Netherlands Antilles +599 </option>
                      <option value="New Caledonia (French) +687">New Caledonia (French) +687 </option>
                      <option value="New Zealand +64">New Zealand +64 </option>
                      <option value="Nicaragua +505">Nicaragua +505 </option>
                      <option value="Niger +227">Niger +227 </option>
                      <option value="Nigeria +234">Nigeria +234 </option>
                      <option value="Niue +683">Niue +683 </option>
                      <option value="Norfolk Island +672">Norfolk Island +672 </option>
                      <option value="Northern Mariana Islands +670">Northern Mariana Islands +670 </option>
                      <option value="Norway +47">Norway +47 </option>
                      <option value="Oman +968">Oman +968 </option>
                      <option value="Pakistan +92">Pakistan +92 </option>
                      <option value="Palau +680">Palau +680 </option>
                      <option value="Panama +507">Panama +507 </option>
                      <option value="Papua New Guinea +675">Papua New Guinea +675 </option>
                      <option value="Paraguay +595">Paraguay +595 </option>
                      <option value="Peru +51">Peru +51 </option>
                      <option value="Philippines +63">Philippines +63 </option>
                      <option value="Poland +48">Poland +48 </option>
                      <option value="Polynesia (French) +689">Polynesia (French) +689 </option>
                      <option value="Portugal +351">Portugal +351 </option>
                      <option value="Puerto Rico +1-787">Puerto Rico +1-787 </option>
                      <option value="Qatar +974">Qatar +974 </option>
                      <option value="Reunion (French) +262">Reunion (French) +262 </option>
                      <option value="Romania +40">Romania +40 </option>
                      <option value="Russia +7">Russia +7 </option>
                      <option value="Rwanda +250">Rwanda +250 </option>
                      <option value="Saint Helena +290">Saint Helena +290 </option>
                      <option value="Saint Kitts &amp; Nevis Anguilla +1-869">Saint Kitts &amp; Nevis Anguilla +1-869 </option>
                      <option value="Saint Lucia +1-758">Saint Lucia +1-758 </option>
                      <option value="Saint Pierre and Miquelon +508">Saint Pierre and Miquelon +508 </option>
                      <option value="Saint Vincent &amp; Grenadines +1-784">Saint Vincent &amp; Grenadines +1-784 </option>
                      <option value="Samoa +684">Samoa +684 </option>
                      <option value="San Marino +378">San Marino +378 </option>
                      <option value="Sao Tome and Principe +239">Sao Tome and Principe +239 </option>
                      <option value="Saudi Arabia +966">Saudi Arabia +966 </option>
                      <option value="Senegal +221">Senegal +221 </option>
                      <option value="Serbia +381">Serbia +381 </option>
                      <option value="Seychelles +248">Seychelles +248 </option>
                      <option value="Sierra Leone +232">Sierra Leone +232 </option>
                      <option value="Singapore +65">Singapore +65 </option>
                      <option value="Slovakia +421">Slovakia +421 </option>
                      <option value="Slovenia +386">Slovenia +386 </option>
                      <option value="Solomon Islands +677">Solomon Islands +677 </option>
                      <option value="Somalia +252">Somalia +252 </option>
                      <option value="South Africa +27">South Africa +27 </option>
                      <option value="Spain +34">Spain +34 </option>
                      <option value="Sri Lanka +94">Sri Lanka +94 </option>
                      <option value="Sudan +249">Sudan +249 </option>
                      <option value="Suriname +597">Suriname +597 </option>
                      <option value="Swaziland +268">Swaziland +268 </option>
                      <option value="Sweden +46">Sweden +46 </option>
                      <option value="Switzerland +41">Switzerland +41 </option>
                      <option value="Syria +963">Syria +963 </option>
                      <option value="Taiwan +886">Taiwan +886 </option>
                      <option value="Tajikistan +992">Tajikistan +992 </option>
                      <option value="Tanzania +255">Tanzania +255 </option>
                      <option value="Thailand +66">Thailand +66 </option>
                      <option value="Togo +228">Togo +228 </option>
                      <option value="Tokelau +690">Tokelau +690 </option>
                      <option value="Tonga +676">Tonga +676 </option>
                      <option value="Trinidad and Tobago +1-868">Trinidad and Tobago +1-868 </option>
                      <option value="Tunisia +216">Tunisia +216 </option>
                      <option value="Turkey +90">Turkey +90 </option>
                      <option value="Turkmenistan +993">Turkmenistan +993 </option>
                      <option value="Turks and Caicos Islands +1-649">Turks and Caicos Islands +1-649 </option>
                      <option value="Tuvalu +688">Tuvalu +688 </option>
                      <option value="U.K. +44">U.K. +44 </option>
                      <option value="Uganda +256">Uganda +256 </option>
                      <option value="Ukraine +380">Ukraine +380 </option>
                      <option value="United Arab Emirates +971">United Arab Emirates +971 </option>
                      <option value="Uruguay +598">Uruguay +598 </option>
                      <option value="Uzbekistan +998">Uzbekistan +998 </option>
                      <option value="Vanuatu +678">Vanuatu +678 </option>
                      <option value="Vatican +39">Vatican +39 </option>
                      <option value="Venezuela +58">Venezuela +58 </option>
                      <option value="Vietnam +84">Vietnam +84 </option>
                      <option value="Virgin Islands (British) +1-28284">Virgin Islands (British) +1-28484 </option>
                      <option value="Virgin Islands (USA) +1-34040">Virgin Islands (USA) +1-34040 </option>
                      <option value="Wallis and Futuna Islands +681">Wallis and Futuna Islands +681 </option>
                      <option value="Yemen +967">Yemen +967 </option>
                      <option value="Zambia +260">Zambia +260 </option>
                      <option value="Zimbabwe +263">Zimbabwe +263 </option>
                    </select>
                  </div>
                  <span className="err_msg" style={ { display: this.state.countrycodeempty ? "inline-block" : "none" } }>Country code cannot be blank</span> </div>
                <div className="common_txtBox_row">
                  <label>Number</label>
                  <input type="text" autoComplete="off" maxLength="20" ref={ this.phoneNUmberFocus } name="phone" value={ this.state.phone } onFocus={ (e) => this.getFocus(e, "phone") } onBlur={ (e) => this.getFocus(e, "lastfield") } onClick={ (e) => this.getFocus(e, "phone") } onChange={ this.handleFormChanges } className="txtBox" />
                  <div className="id-tooltip id-tooltip-topright">
                    <p className="id-tooltip-note">Use atleast:</p>
                    <ul>
                      <li id="min_sev">minimum of 7 characters </li>
                      <li id="max_twe">maximum of 20 characters</li>
                      <li id="no_spe">only characters 0-9 x X - + ()</li>
                    </ul>
                  </div>
                  <span className="err_msg" style={ { display: this.state.phoneNumberEmpty ? 'inline-block' : 'none' } } >Phone Number cannot be blank</span>
                  <span className="err_msg" style={ { display: this.state.phoneregex ? 'inline-block' : 'none' } } >Phone number is invalid</span> </div>
              </div>
              <p className="form_note">Your phone number may help us reach out to you for service related notifications.</p>
            </div>
            <div className="btn_wrap">
              {
                this.state.showPersonDetails
                  ? <input type="submit" name="updateNewCardButton" id="updateNewCardButton" disabled={ !this.props.stripe } value="Add New Card &amp; Save Changes" className="common_cta_btn blue"></input>
                  : <input type="submit" name="updateNewCardButton" id="updateNewCardButton" disabled={ !this.props.stripe } value={ this.state.isSuspended ? "Update & Reactivate Account" : "Add New Card" } className="common_cta_btn blue"></input>
              }
              <input type="button" name="saveChangesButton" id="saveChangesButton" onClick={ this.updateCCDetails } value={ !this.state.isSuspended ? "Save Changes" : "Update & Reactivate Account" } className="common_cta_btn blue"></input>
              <input type={ this.state.cancelButton ? "button" : "hidden" } name="cancelButton" id="cancelButton" onClick={ this.cancelCCUpdate } value="Cancel" className="common_cta_btn cancel"></input>
              <p className="form_note" style={ { display: this.state.isSuspended ? "" : "none" } }>Click on 'Update &amp; Reactivate Account' when you change your card, to pay the pending charges with your new card.</p>
            </div>
          </div>
        </form>
        <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: "", msgType: '' }) } />

        {/* Pop-up HTML elements */ }
        <div className={ this.state.showReactivatePopup ? "main_popup reactivate_popup active" : "main_popup reactivate_popup" }>
          <div className="main_popup_wrapper">
            <div className="main_popup_bg_shadow"></div>
            <div className="main_popup__inner">
              <div className="popup_wrap">
                <span className="close_icon" data-tip data-for="close_icon" title="" data-original-title="Close" onClick={ this.closeReactivatePopup }></span>
                <ReactToolTip id="close_icon" effect="solid" place="top" multiline={ true }>
                  Close
                </ReactToolTip>
                <div className="popup_header">
                  <div className="sub_title">Update and reactivate account</div>
                </div>
                <form>
                  <div className="popup_body">
                    <div className="field_wrap">
                      <p>Your credit card will be charged for <strong>${ this.state.pendingCharges }</strong>, once you click the Continue button.</p>
                    </div>
                    <div className="popup_footer">
                      <div className="popup_footer__btns button_inverse">
                        <button id="reactivateConfirmBtn" ref={ this.reactivateAccConfirmRef } className="btn blue" onClick={ event => { this.reactivateAccConfirm(event); } }>Continue</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className={ this.state.isPhoneVerifyPopup ? "main_popup accModule_mobileOtp_popup active" : "main_popup accModule_mobileOtp_popup" }>
          <div className="main_popup_wrapper">
            <div className="main_popup_bg_shadow"></div>
            <div className="main_popup__inner">
              <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ this.closePhoneVerifyPopup }></span>
                <div className="popup_header">
                  <div className="sub_title">Verify Phone Number</div>
                </div>
                <div className="popup_body">
                  <div className="common_txtBox_row">
                    <p className="resend_msg" id="resend_msg" style={ { display: "none" } }>Verification OTP has been resent.</p>
                    <p className="resend_msg" id="verify_otp_msg" style={ { display: "none" } }>Error occured. Enter a valid OTP.</p>
                    <p>A one time password has been sent to <b>{ this.state.countryLabel }{ this.state.phone }</b></p>
                    <label>Enter the OTP to verify your phone number</label>
                    <input type="password" ref={ this.otpInput } name="otp" id="otp" value={ this.state.otp } className="txtBox" maxLength="6" onChange={ this.handleFormChanges } onKeyUp={ this.handleOTPKeyUp } />
                    <span className="err_msg" style={ { display: this.state.otpempty ? 'inline-block' : 'none' } } >Verification code cannot be blank</span>
                    <span className="err_msg" style={ { display: this.state.otpErr ? 'inline-block' : 'none' } } >Enter a valid OTP</span>
                  </div>
                  <p className="otp-timer" id="otp_timer">Your verification code will expire in <b>5</b> Minutes</p>
                  <div className="popup_footer">
                    <div className="popup_footer__btns">
                      <button className={ this.state.showVerifyLoader ? "btn blue verify_btn submitLoader" : "btn blue verify_btn" } id="verify_btn" disabled={ this.state.otp.length < 6 } onClick={ this.verifyOtp } >Verify</button>
                      <button className="btn blue resend_btn " id="resend_btn" onClick={ () => this.resendOtpSms() }>Resend OTP</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="captcha">
          <ReCAPTCHA
            sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
            onChange={ (e) => this.onRecaptchaChange(e) }
            ref={ this.recaptchaRef }
            size="invisible"
          />
        </div>
      </React.Fragment>
    );
  }
}


export default function InjectedCheckoutForm() {
  return (
    <ElementsConsumer>
      { ({ stripe, elements }) => (
        <CheckoutForm stripe={ stripe } elements={ elements } />
      ) }
    </ElementsConsumer>
  );
}
